import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import { getPayrolls } from '../../../../store/HR/Payroll/PayrollSlice.js';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions.js';
import Breadcrumb from '../../../../components/Shared/Breadcrumb.js';
import Loading from '../../../../components/Shared/Loader/Loading.js';
import AddPayrollRun from './AddPayrollRun.jsx';
import ModalComponent from '../../../../components/Modal/ModalComponent.jsx';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';

const PayrollRun = () => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  // const [show, setShow] = useState(false);
  const [payroll, setPayroll] = useState();

  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const { Payrolls, loading, error } = useSelector(state => state.Payrolls);
  useEffect(() => {
    if (Payrolls?.length === 0) {
      dispatch(getPayrolls());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('TypeOfDuration'), key: 'location' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = Payrolls?.map(item => {
    // let rowClass;
    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      location: item.periodType === 'M' ? t('Monthly') : t('Weekly'),
      action: (
        <div className='btn-group'>
          {/* <button
            type='button'
            data-bs-toggle='modal'
            data-bs-target='#CreateRunPayrolls'
            onClick={() => {
              setPayroll(item);
            }}
            className='btn btn-sm btn-outline-theme'
          >
            <i className='fas fa-lg fa-fw me-2 fa-money-bill-alt'></i>
            {t('CreateRunPayrolls')}
          </button> */}

          <button
            type='button'
            onClick={() => Navigate(`${item.id}/AddRun`)}
            className='btn btn-sm btn-outline-theme'
          >
            <i className='fas fa-lg fa-fw me-2 fa-calculator'></i> {t('AddRun')}
          </button>
        </div>
      )
    };
  });

  const titleModal = () => {
    return (
      <div className=''>
        {t('CreateRunPayrolls')}
        {'  '}
        <span className='text-theme ms-2'>
          {`${i18n.language === 'en' ? payroll?.name : payroll?.name2}`}
        </span>
      </div>
    );
  };

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('RunPayrolls'),
      link: null
    }
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('RunPayrolls')} />

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id='CreateRunPayrolls' title={titleModal()} size='lg'>
        {payroll && <AddPayrollRun payrollId={payroll.id} />}
      </ModalComponent>
    </>
  );
};

export default PayrollRun;
